/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-console */
/* eslint-disable unicorn/no-this-assignment */
import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
const EVENT_KEY = `.lta.cookie.banner`;
const EVENT_FOCUSIN = `focusin${EVENT_KEY}`;

class CookiesBanner {
	constructor() {
		this.Cookies = undefined;
		this.initBanner();
		this.body = SelectorEngine.findOne('body');
	}

	initBanner() {
		this.cookieDomain = location.hostname;
		// One month Duration?
		this.cookieDuration = 90;
		this.banner = SelectorEngine.findOne('#lta-cookies-banner');
		this.openButton = SelectorEngine.findOne('#js-lta-cookie-modal-trigger');
		this.cookiesButton = SelectorEngine.findOne('#lta-cookies-button');
		// third party cookies disabling for LTA play mobile
		const isLTAPLAYMOBILE = document.querySelector('body').getAttribute('data-is-LTAPLAYMOBILE');
		this.isLTAPLAYMOBILE = isLTAPLAYMOBILE === 'True' || isLTAPLAYMOBILE === 'true';
		const thirdPartyCookiesAttribute = document.querySelector('body').getAttribute('data-is-ThirdPartyCookiesDisabled');
		this.disabledThirdPartyCookies = thirdPartyCookiesAttribute === 'True' || thirdPartyCookiesAttribute === 'true';

		if (this.banner) {
			const acceptedValue = {
				func: true,
				perf: true,
				// third party cookies disabling for LTA play mobile
				trgt: this.isLTAPLAYMOBILE ? !this.disabledThirdPartyCookies : true,
				thrd: this.isLTAPLAYMOBILE ? !this.disabledThirdPartyCookies : true
			};
			const acceptedCookie = JSON.stringify(acceptedValue);

			import('js-cookie')
				.then(({ default: Cookies }) => {
					const self = this;
					this.Cookies = Cookies;

					// Function to set consent cookie
					const setConsent = function (consent, value) {
						Cookies.set('consent', consent, { domain: self.cookieDomain, expires: self.cookieDuration });

						try {
							window.dataLayer.push({
								event: 'cookie-consent',
								funcCategory: true,
								perfCategory: true,
								trgtCategory: value,
								thrdCategory: value,
								ad_storage: 'granted',
								ad_user_data: 'granted',
								ad_personalization: 'granted',
								analytics_storage: 'granted',
								clicked: 'Accept all'
							});
							// As some of the required events are not being pushed with above event. Initialization the init event again. Nedd to find a better solution.
							window.dataLayer.push({ 'event': 'gtm.init', 'gtm.uniqueEventId': 0 });
						} catch (error) {
							console.log(error.message);
						}
						window.location.reload();
					};

					if (!Cookies.get('cookieprefs')) {
						this.banner.classList.add('pre-visible');
						// Nest RAF calls to ensure that display change above is set in order for animation to work as expected
						requestAnimationFrame(() =>
							requestAnimationFrame(() => {
								this.banner.classList.add('is-visible');
							})
						);
						// aria hidden true/false toggle
						this.toggleBodyClass();
						this.banner.setAttribute('aria-hidden', 'false');
						this._enforceFocus();
					}

					// Banner Button Click Event
					// Accept all Cookies
					EventHandler.on(this.cookiesButton, 'click', () => {
						const event = new CustomEvent('cookiesAcceptance');
						window.dispatchEvent(event);
						Cookies.set('cookieprefs', acceptedCookie, { domain: self.cookieDomain, expires: this.cookieDuration });
						if (!acceptedValue.func || !acceptedValue.perf || !acceptedValue.trgt) {
							if (this.isLTAPLAYMOBILE && this.disabledThirdPartyCookies) {
								setConsent(false, !this.disabledThirdPartyCookies);
							} else if (this.isLTAPLAYMOBILE && !this.disabledThirdPartyCookies) {
								setConsent(false, this.disabledThirdPartyCookies);
							}
						} else {
							setConsent(true, true);
						}
						this.banner.classList.remove('is-visible');
						EventHandler.one(this.banner, 'transitionend', () => {
							this.banner.classList.remove('pre-visible');
						});
						this.toggleBodyClass();
						this.banner.setAttribute('aria-hidden', 'true');
						this._disableFocus();
					});

					return 1;
				})
				.catch((error) => {
					console.log(error);
				});
		}
	}

	_enforceFocus() {
		EventHandler.off(document, EVENT_FOCUSIN); // guard against infinite focus loop
		EventHandler.on(document, EVENT_FOCUSIN, (event) => {
			if (document !== event.target && this.banner !== event.target && !this.banner.contains(event.target)) {
				this.openButton.focus();
			}
		});
	}

	_disableFocus() {
		EventHandler.off(document, EVENT_FOCUSIN);
	}

	toggleBodyClass() {
		this.body.classList.toggle('cookies-modal-open');
	}
}
const globalCookiesBanner = new CookiesBanner();

export default globalCookiesBanner;
